import React, {useEffect, useState} from 'react';
import { addDays, formatDate } from "../../../Utis/GlobalFunctions";
import axios from "axios";
import Swal from 'sweetalert2';
import CircularLoader from "../../../Component/CircularLoader";
import logo from "../../../assets/images/OnlineDonationBanner2.png"

const DarUlSukoonDonation = () => {
    const [currentDate] = useState(new Date())
    const newDate = addDays(currentDate, 3);
    const [loading,setLoading] = useState(false)
    const [credentials] = useState({
            username: "DS_Donation",
            password: "Donate@live09",
            clientId: "0zdp4mouYe44ho4",
            clientSecret: "eGXtLQtyYpmEIGm"
    });
    // State to handle form input values
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        amount: '',
        address: '',
        currency: '',
    });

    // State to handle errors
    const [errors, setErrors] = useState({});


    let payload
    if(formData.currency === "PKR") {
        console.log("Working PKR")
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                OrderAmount: formData?.amount,
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: formData?.name,
                CustomerMobile: formData?.currency === "PKR" ? formData?.phoneNumber : "",
                CustomerEmail: formData?.email,
                CustomerAddress: formData?.address,
                BillDetail01: [
                    {
                        internationalNumber: formData?.currency !== "PKR" ? formData?.phoneNumber : "",
                    }
                ]
            }
        ];
    }else {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                CurrencyAmount: formData?.amount,
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: formData?.name,
                CustomerMobile: formData?.currency === "PKR" ? formData?.phoneNumber : "",
                CustomerEmail: formData?.email,
                CustomerAddress: formData?.address,
                Currency: formData?.currency,
                IsConverted  : "true",
                BillDetail01: [
                    {
                        internationalNumber: formData?.currency !== "PKR" ? formData?.phoneNumber : "",

                    }
                ]
            }
        ];
    }

    console.log(payload,"payload")


    const currencyData = [
        { id: 1, name: "PKR", value: "PKR" },
        { id: 2, name: "USD", value: "USD" },
        { id: 3, name: "EUR", value: "EUR" },
        { id: 4, name: "GBP", value: "GBP" },
        { id: 5, name: "CAD", value: "CAD" },
        { id: 6, name: "AUD", value: "AUD" },
        { id: 7, name: "AED", value: "AED" },
    ];


    // Handle input changes and update form data
    // Handle input changes and update form data with real-time validation
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Update the form data state
        setFormData({
            ...formData,
            [name]: value,
        });

        // Validate the specific field on change
        validateField(name, value);
    };

// Real-time field validation
    const validateField = (name, value) => {
        let fieldError = {};

        switch (name) {
            case "name":
                if (!value) {
                    fieldError.name = "Name is required.";
                } else {
                    fieldError.name = ""; // Clear error if input is valid
                }
                break;
            case "email":
                if (!value) {
                    fieldError.email = "Email is required.";
                } else if (!/\S+@\S+\.\S+/.test(value)) {
                    fieldError.email = "Email address is invalid.";
                } else {
                    fieldError.email = ""; // Clear error if input is valid
                }
                break;
            case "phoneNumber":
                if (!value) {
                    fieldError.phoneNumber = "Phone number is required.";
                } else {
                    fieldError.phoneNumber = ""; // Clear error if input is valid
                }
                break;
            case "currency":
                if (!value) {
                    fieldError.currency = "Currency is required.";
                } else {
                    fieldError.currency = ""; // Clear error if input is valid
                }
                break;
            case "amount":
                if (!value) {
                    fieldError.amount = "Amount is required.";
                } else if (formData?.currency === "PKR" && value < 500) {
                    fieldError.amount = "Amount must be at least 500 PKR.";
                } else if (formData?.currency === "USD" && value < 5) {
                    fieldError.amount = "Amount must be at least $5 for USD.";
                } else {
                    fieldError.amount = ""; // Clear error if input is valid
                }
                break;

            default:
                break;
        }

        // Update errors state
        setErrors((prevErrors) => ({
            ...prevErrors,
            ...fieldError,
        }));
    };



    // Validate form inputs
    const validateForm = () => {
        const newErrors = {};

        // Check if the name field is empty
        if (!formData.name) newErrors.name = "Name is required.";

        // Check if the email is empty or not valid
        if (!formData.email) {
            newErrors.email = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Email address is invalid.";
        }

        // Check if the phone number field is empty
        if (!formData.phoneNumber) newErrors.phoneNumber = "Mobile Number is required.";


        if (!formData.currency) newErrors.currency = "Currency is required.";


        // Check if the amount field is empty
        if (!formData.amount) newErrors.amount = "Amount is required.";

        // Check if the address field is empty
        // if (!formData.address) newErrors.address = "Address is required.";

        setErrors(newErrors);

        // Return whether the form is valid or not
        return Object.keys(newErrors).length === 0;
    };

    const getAuthToken = async (clientId, clientSecret) => {
        const tokenResponse = await axios.post(`${process.env.REACT_APP_PAYPRO_LIVEAPI}/auth`, {
            clientid: clientId,
            clientsecret: clientSecret,
        });
        return tokenResponse.data.token;
    };

    const payproCreateOrder = async (e) => {
        e.preventDefault();



        // Validate the form before submission
        const isValid = validateForm();
        if (!isValid) {
            // If the form has errors, prevent submission
            return;
        }

        try {
            setLoading(true);
            const token = await getAuthToken(credentials.clientId, credentials.clientSecret);
            const headers = { 'token': token, 'Content-Type': 'application/json' };
            const url = `${process.env.REACT_APP_PAYPRO_LIVEAPI}/create-order`;
            const response = await axios.post(url, payload, { headers });

            if(response.data?.data[0].Status === "03") {
                console.log(response.data.data[1].Description)
                await Swal.fire({
                    icon: "error",
                    title: response?.data?.data[1]?.Description,
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
            }else {
                const marketplaceUrl = response.data?.data[1]?.Click2Pay
                await Swal.fire({
                    icon: "success",
                    title: "Redirecting to Marketplace",
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
                window.top.location.href = marketplaceUrl;
            }

            // return response.data;


        } catch (error) {
            console.error('Error creating order:', error);
            setLoading(false)
        }

    }


    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://www.currency.wiki/widget/embed?f=EUR&t=USD&a=1&fc=ffffff&c=A94442&g=on&sh=on&b=on&fl=on&p=c&s=off&mf=1&df=2&d=1&su=on&l=https://www.currency.wiki/&cd=8808907ce2483e3b39325779c309c812&w=200&h=350&lang=en-US";
        script.async = true;

        const widgetContainer = document.getElementById("currency-widget-container");
        if (widgetContainer) {
            widgetContainer.appendChild(script);
        }

        return () => {
            if (widgetContainer) {
                widgetContainer.innerHTML = ""; // Clean up the script on component unmount
            }
        };
    }, []);

    return (
        <div className="w-11/12 lg:w-2/3 md:w-4/5 bg-white border-4 rounded-lg    shadow relative m-auto">
            <form className="p-6 space-y-6" onSubmit={payproCreateOrder}>
                <img className='w-full h-full' src={logo} alt={logo} />
                <h3 className='text-center text-3xl uppercase font-Poppins font-semibold '>Donation</h3>
                <div className="w-full flex lg:flex-row flex-col justify-between  items-center gap-4">
                    <div className="w-full xl:w-9/12 lg:w-2/3 grid grid-cols-6 gap-6">
                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Name <span>*</span></label>
                            <input
                                type="text"
                                name="name"
                                value={formData?.name}
                                onChange={handleChange}
                                className="w-full border px-2 py-2 rounded-lg shadow-md text-sm bg-white"
                                placeholder="Full Name"
                            />
                            {errors.name && <p className="text-red-600 text-sm">{errors.name}</p>}
                        </div>

                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Email <span>*</span></label>
                            <input
                                type="email"
                                name="email"
                                value={formData?.email}
                                onChange={handleChange}
                                className="w-full border px-2 py-2 rounded-lg shadow-md text-sm bg-white"

                                placeholder="Your Email Address"
                            />
                            {errors.email && <p className="text-red-600 text-sm">{errors.email}</p>}
                        </div>

                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Phone Number <span>*</span></label>
                            <input
                                type="tel"
                                name="phoneNumber"
                                value={formData?.phoneNumber}
                                onChange={handleChange}
                                className="w-full border px-2 py-2 rounded-lg shadow-md text-sm bg-white"

                                placeholder="Phone Number (03XXXXXXXXX)"
                            />
                            {errors.phoneNumber && <p className="text-red-600 text-sm">{errors.phoneNumber}</p>}
                        </div>

                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Address </label>
                            <input
                                type="text"
                                name="address"
                                value={formData?.address}
                                onChange={handleChange}
                                className="w-full border px-2 py-2 rounded-lg shadow-md text-sm bg-white"

                                placeholder="Address"
                            />
                            {errors.address && <p className="text-red-600 text-sm">{errors.address}</p>}
                        </div>

                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Currency <span>*</span></label>
                            <NewSelect
                                selectValue={formData?.currency}
                                setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                                name="currency"
                                data={currencyData}
                            />
                            {errors.currency && <p className="text-red-600 text-sm">{errors.currency}</p>}
                        </div>

                        <div className="col-span-6 sm:col-span-3">
                            <label className="text-md font-medium text-gray-900 block mb-2">Amount <span>*</span></label>
                            <input
                                type="text"
                                name="amount"
                                value={formData?.amount}
                                onChange={handleChange}
                                className="w-full border px-2 py-2 rounded-lg shadow-md text-sm bg-white"
                                placeholder={
                                    formData?.currency === "PKR"
                                        ? "Minimum Amount RS 500"
                                        : formData?.currency === ""
                                            ? ""
                                            : formData?.currency === "USD"
                                                ? "Minimum Amount $5"
                                                : ""
                                }
                            />
                            {errors.amount && <p className="text-red-600 text-sm">{errors.amount}</p>}
                        </div>

                    </div>
                    <div className="w-full  xl:w-3/12 lg:w-1/3  flex items-center mt-5 justify-center ">
                        {/* The link is for attribution as required */}
                        <a href="https://www.currency.wiki/" rel="nofollow">
                            Currency.Wiki
                        </a>
                        {/* Container where the widget will be embedded */}
                        <div id="currency-widget-container"></div>
                    </div>
                </div>
                <div className="flex items-center justify-center">
                    <button
                        type="submit"
                        className="w-full text-center justify-center flex items-center gap-1  py-2 px-4 text-white bg-black  focus:ring-4 focus:ring-white font-medium rounded-lg text-md"
                    >
                        Submit {loading ? <CircularLoader/> : null}
                    </button>
                </div>
            </form>

        </div>
    );
};

export default DarUlSukoonDonation;



export const NewSelect = ({ data, selectValue, setSelectValue, name }) => {
    return (
        <div className="w-full">
            <select
                value={selectValue || ""}  // Use selectValue to show the selected value
                onChange={(e) => setSelectValue(name, e.target.value)}  // Pass the name and value
                className="w-full border px-2 py-2 rounded-lg shadow-md text-sm bg-white"
            >
                <option value="" disabled>
                    Please select the option
                </option>

                {data?.map((item, index) => (
                    <option key={index} value={item?.value}>
                        {item?.name}
                    </option>
                ))}
            </select>
        </div>
    );
};


